<template>
    <div class="top">
        <div class="w1200">
            <div class="left">
            <div class="logobox">
              <img :src="logo" alt="" @click="indexpage">
            </div>
            <ul class="nav">
                <li>
                    <a href="javascript:;" class="a1">{{language[languagetype].about}}</a>
                    <div class="subnav">
                      <router-link :to="{name:'about'}" class="a2">{{language[languagetype].company}}</router-link>
                      <router-link :to="{name:'service'}" class="a2">{{language[languagetype].service}}</router-link>
                      <router-link :to="{name:'contact'}" class="a2">{{language[languagetype].contact}}</router-link>
                    </div>
                </li>
                <li>
                    <a href="javascript:;" class="a1">{{language[languagetype].onlineservice}}</a>
                    <div class="subnav">
                      <a href="javascript:;" class="a2" @click="trackpagebtn">{{language[languagetype].trackpage}}</a>
                      <a href="javascript:;" class="a2" @click="orderbtn">{{language[languagetype].order}}</a>
                      <a href="javascript:;" class="a2" @click="reportbtn">{{language[languagetype].report}}</a>
                      <a href="javascript:;" class="a2" @click="expressbtn">{{language[languagetype].express}}</a>
                    </div>
                </li>
                <li>
                  <router-link :to="{name:'newslist',params:{id: 1}}" class="a1">{{language[languagetype].news}}</router-link>
                </li>
                <li>
                  <a href="javascript:;" class="a1" @click="downpagepage">{{language[languagetype].downtitle}}</a>
                </li>
            </ul>
        </div>
        <div class="right">
            <div class="select">
              <div class="language">{{language[languagetype].lang}}</div>
              <ul class="languagelist">
                <li><a href="javascript:;" @click="changelanguage(1)">中文</a></li>
                <li><a href="javascript:;" @click="changelanguage(2)">English</a></li>
              </ul>
            </div>
            <div class="loginbtn" @click="loginpage" v-if="username==null">
              {{language[languagetype].login}}
            </div>
            <div class="logins" v-if="username!=null">
              {{username.userName}} <span @click="toforget">{{language[languagetype].password}}</span> <span @click="zhuxiao">{{language[languagetype].quit}}</span>
            </div>
        </div>
        </div>
        <toast ref="toasttext"></toast>
    </div>
</template>

<script>
import Fetch from '../js/ajaxa'
import toast from '../components/taast/toast'
let languagetext = require('../js/index.json')
export default {
  name: 'index',
  data () {
    return {
      username: '',
      logo: '',
      lang: 1,
      language: {},
      languagetype: 'cn'
    }
  },
  methods: {
    indexpage: function () {
      this.$router.push({name: 'index'})
    },
    loginpage: function () {
      this.$router.push({name: 'login'})
    },
    toforget: function () {
      this.$router.push({name: 'forget'})
    },
    trackpagebtn: function () {
      const that = this
      if (that.username == null) {
        setTimeout(function () {
          that.$refs.toasttext.show(that.language[that.languagetype].islogin)
        }, 300)
        setTimeout(function () {
          that.$router.push({name: 'login'})
        }, 1000)
        return false
      }
      this.$router.push({name: 'trackpage'})
    },
    orderbtn: function () {
      const that = this
      if (that.username == null) {
        setTimeout(function () {
          that.$refs.toasttext.show(that.language[that.languagetype].islogin)
        }, 300)
        setTimeout(function () {
          that.$router.push({name: 'login'})
        }, 1000)
        return false
      }
      this.$router.push({name: 'order'})
    },
    reportbtn: function () {
      const that = this
      if (that.username == null) {
        setTimeout(function () {
          that.$refs.toasttext.show(that.language[that.languagetype].islogin)
        }, 300)
        setTimeout(function () {
          that.$router.push({name: 'login'})
        }, 1000)
        return false
      }
      this.$router.push({name: 'report'})
    },
    downpagepage: function () {
      const that = this
      if (that.username == null) {
        setTimeout(function () {
          that.$refs.toasttext.show(that.language[that.languagetype].islogin)
        }, 300)
        setTimeout(function () {
          that.$router.push({name: 'login'})
        }, 1000)
        return false
      }
      this.$router.push({name: 'download'})
    },
    zhuxiao: function () {
      localStorage.removeItem('username')
      this.$router.push({name: 'index'})
    },
    changelanguage: function (id) {
      sessionStorage.setItem('lang', id)
      if (this.$route.name === 'newslist' || this.$route.name === 'newspage') {
        if (id === 1) {
          this.$router.push({name: 'newslist', params: {id: 1}})
          this.$router.go(0)
        } else {
          this.$router.push({name: 'newslist', params: {id: 4}})
          this.$router.go(0)
        }
      } else {
        this.$router.go(0)
      }
    },
    expressbtn: function () {
      const that = this
      if (that.username == null) {
        setTimeout(function () {
          that.$refs.toasttext.show(that.language[that.languagetype].islogin)
        }, 300)
        setTimeout(function () {
          that.$router.push({name: 'login'})
        }, 1000)
        return false
      }
      this.$router.push({name: 'express'})
    }
  },
  created () {
    const that = this
    that.language = languagetext
    that.username = JSON.parse(localStorage.getItem('username'))
    that.lang = sessionStorage.getItem('lang') || 1
    // eslint-disable-next-line
    if (that.lang != 1) {
      that.languagetype = 'en'
    }
    Fetch.post('Api/config', {
    }).then((res) => {
      that.logo = res.image
    }).catch(err => {
      console.log(err)
    })
  },
  components: {
    toast
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .top{width: 100%;height: 80px;overflow: visible;}
    .top .left{float: left;}
    .top .w1200{overflow:visible}
    .top .left .logobox{display: block;width: 168px;height: 70px;float: left;display: flex;align-items: center;overflow: hidden;margin-top: 5px;}
    .top .left .logobox img{width: auto;height: auto;max-width: 100%;max-height: 100%;cursor: pointer;}
    .nav{float: left;margin-left: 20px;}
    .nav li{width: auto;min-width: 107px; height: 80px;float: left;position: relative;margin-right: 10px;}
    .nav li .a1{display: block;line-height: 80px;text-align: center;width: 100%;text-decoration: none;color: #999999;font-size: 16px;}
    .nav li .subnav{min-width: 107px;width: auto; height: auto;overflow:visible;background-color: #fff;border-radius: 4px;position: absolute;top: 67px;left: 0;padding: 9px 4px 9px 0;box-sizing: border-box;display: none;}
    .nav li:hover .a1{color: #333;font-weight: bold;}
    .nav li .subnav::before{content: "";position: absolute;top: -5px;left: 53px;display: block;width: 10px;height: 5px;background: url("../assets/jiantou.png") 0 0 no-repeat;}
    .nav li .subnav .a2{display: block;height: 32px;position: relative;text-indent: 32px;line-height: 32px;color: #999999;white-space: nowrap}
    .nav li .subnav .a2::after{content: "";display: block;width: 6px;height: 6px;border-radius: 50%;background-color: #999999;position: absolute;left: 14px;top: 13px;}
    .nav li .subnav .a2:hover{color: #1c5cef;}
    .nav li .subnav .a2:hover::after{background-color: #1c5cef;}
    .nav li:hover .subnav{display: block;box-shadow: 2px 2px 5px rgba(0,0,0,0.3);}
    .top .right{float: right;}
    .top .right .select{min-width: 70px;height: 80px;line-height: 80px;font-size: 14px;color: #ffffff;float: left;position: relative;}
    .top .right .select .language{width: 70px;height: 80px;line-height: 80px;font-size: 14px;color: #333;background: url("../assets/xiala2.png") right center no-repeat;cursor: pointer;}
    .top .right .select .languagelist{width: 107px;height: auto;overflow: hidden;display: none;position: absolute;top: 60px;left: 0;background-color: #fff;border-radius: 4px;padding: 9px 0;box-sizing: border-box;}
    .top .right .select .languagelist li{width: 100%;height: 40px;line-height: 40px;}
    .top .right .select .languagelist li a{display: block;text-indent: 10px;text-decoration: none;color: #999999;}
    .top .right .select .languagelist li a:hover{color: #1c5cef;}
    .top .right .select:hover .languagelist{display: block;box-shadow: 2px 2px 5px rgba(0,0,0,0.3);}
    .top .right .loginbtn{min-width: 95px;height: 80px;line-height: 80px;float: left;margin-left: 37px;font-size: 14px;color: #999;text-indent: 30px;background: url("../assets/user2.png") 0 center no-repeat;cursor: pointer;}
    .top .right .logins{width: auto;height: 80px;line-height: 80px;float: left;margin-left: 37px;font-size: 14px;color: #999;cursor: pointer;}
    .top .right .logins span:hover{color: #333;}
</style>



// WEBPACK FOOTER //
// src/page/header.vue